import { Link } from 'react-router-dom';
import { siteStats } from '@/mocks/homeMocks';

export default function AboutSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 max-w-xl">
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-semibold mb-5">
              HANMAN LEADER
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
              韩漫大全 — 韩国漫画在线阅读标杆平台
            </h2>
            <div className="space-y-4 text-foreground-700 leading-relaxed text-sm md:text-base">
              <p>
                <strong>韩漫大全免费</strong>平台自成立以来，始终致力于为广大漫画爱好者提供最优质的<strong>韩国漫画</strong>在线阅读服务。作为行业内的<strong>在线阅读网</strong>标杆，我们每日更新最新章节，确保读者能够第一时间追到自己喜爱的作品。
              </p>
              <p>
                平台汇聚了超过<strong>{siteStats.totalComics.toLocaleString()}</strong>部<strong>韩漫资源</strong>，涵盖恋爱、动作、奇幻、悬疑、科幻、搞笑、恐怖、日常等八大分类。无论你喜欢什么类型的漫画，都能在这里找到心仪的作品。
              </p>
              <p>
                我们提供完善的<strong>评论收藏</strong>系统，让读者可以与其他漫迷交流心得，轻松追踪自己喜欢的漫画更新。所有漫画均可免费在线阅读，无需任何费用。
              </p>
            </div>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-full bg-secondary-500 text-background-50 font-semibold text-sm hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解我们
              <i className="ri-arrow-right-line"></i>
            </Link>

            <div className="mt-12 grid grid-cols-3 gap-6">
              <div>
                <div className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
                  {siteStats.totalComics.toLocaleString()}+
                </div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">漫画总数</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
                  {(siteStats.totalUsers / 10000).toLocaleString()}万+
                </div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">累计用户</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-heading font-bold text-accent-500">
                  {siteStats.avgRating}
                </div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">平均评分</div>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20editorial%20studio%20scene%2C%20artists%20working%20on%20digital%20illustration%20tablets%2C%20warm%20ambient%20lighting%2C%20creative%20workspace%20with%20manga%20posters%20on%20wall%2C%20modern%20Korean%20office%20aesthetic%2C%20olive%20green%20and%20cream%20color%20palette%2C%20soft%20natural%20light%20from%20window%2C%20clean%20composition&width=900&height=675&seq=about-platform&orientation=landscape"
                alt="韩漫大全编辑团队 - 韩国漫画在线阅读网"
                title="韩漫大全编辑团队"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <p className="text-white font-heading font-bold text-lg">韩漫大全</p>
                <p className="text-white/70 text-sm">您的韩漫阅读首选平台</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}